import { ISagaModule } from 'redux-dynamic-modules-saga';
import { moduleLoadableSaga } from './sagas/module';
import reducers from './reducers';
import { reduxModuleLoaded } from './actions';

export function getModule(): ISagaModule<{}> {
  return {
    id: 'deviationSubmit',
    reducerMap: reducers,
    sagas: [moduleLoadableSaga],
    initialActions: [reduxModuleLoaded()],
    retained: true,
  };
}
